import { types } from "./actions";

const initialState = {
  selectBriefcase: {}
};

const briefcaseReducer = (state = initialState, action) => {
  const {briefcase,type} = action;

  switch (type) {
    case types.selectBriefcase:
      return {
        ...state,
        selectBriefcase:briefcase
      };  
    default:
      return state
  }
};
export default briefcaseReducer;
